// ============================================
// Creator Module - API Endpoints (ES6)
// ============================================

// 중앙 엔드포인트에서 가져옴
import { CREATOR_ENDPOINTS } from '../shared/api-endpoints.js';

// 하위 호환성을 위해 ENDPOINTS로 re-export
export const ENDPOINTS = CREATOR_ENDPOINTS;
